/**
 * Configuration file for environment variables
 * This centralizes all environment variable access
 */

const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  APP_URL: process.env.REACT_APP_APP_URL || 'http://localhost:5000',
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || 'http://localhost:5000',
  API_GATEWAY_URL: process.env.REACT_APP_API_GATEWAY_URL || 'http://localhost:3001/api',
  AUTH_SERVICE_URL: process.env.REACT_APP_AUTH_SERVICE_URL || 'http://localhost:3001',
  PROFESSIONS_SERVICE_URL: process.env.REACT_APP_PROFESSIONS_SERVICE_URL || 'http://localhost:3002',
  GOOGLE_TAG_MANAGER_ID: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
  // Shared Clock In / Clock Out widget bundle served by attendance-service (empty = off)
  CLOCK_WIDGET_URL: process.env.REACT_APP_CLOCK_WIDGET_URL || '',
};

// Экспортируем отдельные переменные для удобства импорта
export const { API_URL, APP_URL, SOCKET_URL, API_GATEWAY_URL, AUTH_SERVICE_URL, CLOCK_WIDGET_URL } = config;

export default config;
